export const REFERRAL_WINNING_PERCENTANGE = 50;
export const FRIEND_REFERRAL_WINNING_PERCENTANGE = 5;
